import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { Fusszeile } from '../components/Fusszeile';

/**
 * Gemeinsame Hülle **aller** Seiten (Änderungsanforderung ÄA-2).
 *
 * Eine pfadlose Layout-Route statt einer Fußzeile je Hülle: Teilnehmerbereich, Anmeldeseiten und
 * Administrationsbereich liegen darunter, und die Fußzeile steht damit nur an einer Stelle im
 * Quelltext.
 *
 * **Die Höhe wird hier geführt.** Diese Hülle beansprucht die volle Ansichtshöhe; die inneren
 * Bereiche füllen mit `flex-1` den Raum darüber. Behielten sie ihr früheres `min-h-dvh`, entstünde
 * auf jeder Seite eine Bildlaufleiste in Fußzeilenhöhe.
 */
export function AppLayout(): ReactElement {
  return (
    <div className="flex min-h-dvh flex-col">
      <div className="flex flex-1 flex-col">
        <Outlet />
      </div>
      <Fusszeile />
    </div>
  );
}
